export default __webpack_public_path__ + "static/media/a011-startup-02.4e69ba33.svg";